import React, { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import useFetch from '../../../hooks/useFetch';
import useMe from "../../../hooks/useMe";
import ActionButton from "../../Shared/ActionButton";
import useShipmentSnackbar from "../../Shared/useShipmentSnackbar";

export default ({
  orderEx,
  updateSbOrderData
}) => {
  const {
    _id,
  } = orderEx?.data || {}

  const {
    id
  } = orderEx?.dataSb || {}

  const [isShowModal, setIsShowModal] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const fetch = useFetch();

  const shipmentSnackbar = useShipmentSnackbar()
  
  const { hasShipmentTrackingPublish: hasPublish } = useMe()

  const markOrderAsDelivered = async () => {
    setIsBusy(true)
    try {
      // We need to provide shipbobOrderId in case this is a shipbob only record
      const data = JSON.stringify({
        ...orderEx?.data,
        shipbobOrderId: id,
        overrideStatus: 'delivered'
      })
      const headers = {
        "Content-Type": "application/json",
      }
      const response = await fetch('shipping/order/markDelivered', { method: 'POST', headers, body: data })
      const jsonData = await response.json()

      if (jsonData.error) {
        console.error(jsonData.error)
        shipmentSnackbar.newMessage({ message: 'Error marking order as delivered', severity: 'failure' })
      } else {
        console.log({ jsonData })
        await updateSbOrderData?.(jsonData.data)
        onClose()
      }
      
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error marking order as delivered', severity: 'failure' })
    } finally {
      setIsBusy(false)
    }
  }

  const onClose = () => {
    setIsShowModal(false)
  }

  const onClickSubmit = () => {
    markOrderAsDelivered()
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      fontSize: '16px',
      fontWeight: 'normal',
      padding: '10px'
    }}>
      {
        Boolean(isBusy) &&
        <div>{'Updating...'}</div>
      }
      <Button onClick={() => (!isBusy && onClose())} $disabled={isBusy}>
        {'Cancel'}
      </Button>
      <Button onClick={() => (!isBusy && onClickSubmit())} $disabled={isBusy} $colored={true}>
        {'Submit'}
      </Button>
    </div>
  )

  return (<>
    { hasPublish && <>
      { isShowModal &&
        <Modal title='Mark Order as Delivered' onClose={onClose} footer={footer} isAutoHeight={true}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            fontSize: '16px',
            fontWeight: 'normal'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '15px'
            }}>
              <div>{`This action cannot be undone.`}</div>
              <div><strong>{`Are you sure you want to mark this order as delivered #${id || _id}?`}</strong></div>
            </div>
          </div>
        </Modal>
      }

      <ActionButton onClick={() => setIsShowModal(true)}>
        Mark Order as Delivered
      </ActionButton>
    </>}
  </>)
}
